import { AlertCircle } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface FormErrorProps {
  id?: string;
  message: string;
  className?: string;
}

export const FormError = ({ id, message, className }: FormErrorProps) => {
  return (
    <p
      id={id}
      role="alert"
      aria-live="polite"
      className={cn('text-destructive flex items-center gap-1.5 text-sm', className)}
    >
      <AlertCircle className="h-3.5 w-3.5 flex-shrink-0" />
      <span>{message}</span>
    </p>
  );
};
